<script>
export default {
  props: {
    width: {
      type: [String, Number],
      default: '1.5rem',
    },
    height: {
      type: [String, Number],
      default: '1.5rem',
    },
    title: {
      type: String,
      default: 'Success:',
    },
    isDecorative: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ariaLabel() {
      return this.isDecorative ? null : this.title
    },
  },
}
</script>

<template>
  <svg
    role="img"
    :aria-label="ariaLabel"
    :aria-hidden="isDecorative"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    :style="{ width, height }"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <title>{{ title }}</title>
    <g>
      <path
        d="M6.5 13.1211L8.74583 16.3084C8.83102 16.4356 8.94537 16.5407 9.07936 16.6148C9.21335 16.689 9.36311 16.73 9.51617 16.7346C9.66924 16.7392 9.82118 16.7071 9.95936 16.6411C10.0975 16.5751 10.2179 16.4771 10.3106 16.3551L17.5 7.25903"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M1.6875 11.999C1.6875 14.7341 2.77399 17.3571 4.70796 19.2911C6.64193 21.225 9.26496 22.3115 12 22.3115C14.735 22.3115 17.3581 21.225 19.292 19.2911C21.226 17.3571 22.3125 14.7341 22.3125 11.999C22.3125 9.26398 21.226 6.64095 19.292 4.70698C17.3581 2.77302 14.735 1.68652 12 1.68652C9.26496 1.68652 6.64193 2.77302 4.70796 4.70698C2.77399 6.64095 1.6875 9.26398 1.6875 11.999Z"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </g>
  </svg>
</template>
